import React, { forwardRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Camera, OpStatus, DetectorConfig, Link } from 'NSwag/ServerClient/Client.nswag';
import { Typography } from '@material-ui/core';
import NotAvailable from "Resources/Images/CctvIcons/NotAvailable.png";
import { getOpStatusDescription } from 'Util/OpStatusUtils';
import { ILanePollData } from 'Store/index';
import Util from 'Util/index';

const useStyles = makeStyles(theme => ({
    container: {
        backgroundColor: '#ffffff',
        padding: theme.spacing(2),
        borderRadius: 5
    },
    streamContainer: {
        maxWidth: 100,
        maxHeight: 100
    }
}));

interface IProps {
    link: Link;
    pollData?: ILanePollData;
}

const TssLinkTooltip = ({ link, pollData }: IProps) => {

    const classes = useStyles();

    return (
        <div className={classes.container}>
            <Typography variant="body1">
                {link.displayName}
            </Typography>
            {
                link.lanes && pollData &&
                link.lanes.map((l, index) => {
                    let laneKey = Util.IdToString(l.id!);
                    let lanePollData = pollData[laneKey];
                    return (
                        <div key={index}>
                            {
                                lanePollData &&
                                <Typography variant="body2">
                                    {
                                        `${l.detectionZone!.zoneNumber} - ${lanePollData.smoothedData!.speed} MPH    ${(lanePollData.smoothedData!.occupancy ?
                                        `${lanePollData.smoothedData!.occupancy}%` :
                                        'N/A')}    ${lanePollData.rawData!.volume} Veh`
                                    }
                                </Typography>
                            }
                            {
                                !lanePollData &&
                                <Typography variant="body2">
                                    {l.detectionZone!.zoneNumber} -  No lane data available.
                                </Typography>
                            }
                        </div>
                    )
                })
            }
        </div>
    );
};

export default TssLinkTooltip;